import { createSlice } from "@reduxjs/toolkit";
// utils
import { Bounce, toast } from "react-toastify";
import axiosInstance from "../../utils/axios";
import {
  getFirstLineUps,
  getSecondLineUps,
  updatePlayerInMatch,
} from "./lineup";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  activity: null,
  firstTeamActivities: [],
  secondTeamActivities: [],
  fetchLoading: false,
  activities: [],
};

const slice = createSlice({
  name: "substitute",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    starFetchtLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // GET DATA success

    getActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = action.payload;
    },

    getFirstActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.firstTeamActivities = action.payload;
    },

    getSecondActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.secondTeamActivities = action.payload;
    },

    // POST DATA success
    postSubstituteSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      // state.activities = [...action.payload.data, ...state.activities];
    },

    deleteActivitySuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = state.activities.filter(
        (act) => act.id !== action.payload
      );
    },

    updateActivitySuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = state.activities.map((act) => {
        if (act.id === action.payload.id) {
          return action.payload;
        } else {
          return act;
        }
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

// TODO: get activities``
export function getActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`substitutes`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });
      dispatch(slice.actions.getActivitiesSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update activities``
export function updateActivity({
  team_id,
  game_id,
  player_id,
  type,
  activity_id,
  points,
  setOpenEdit,
  singleGame,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.patch(`substitutes/${activity_id}`, {
        team_id,
        game_id,
        player_id,
        type,
        points,
      });
      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
        })
      );
      setOpenEdit(false);
      dispatch(slice.actions.updateActivitySuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get activities``
export function getFirstTeamActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`substitutes`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });

      dispatch(
        slice.actions.getFirstActivitiesSuccess(response.data.data.data)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get activities``
export function getSecondTeamActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`substitutes`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });
      dispatch(
        slice.actions.getSecondActivitiesSuccess(response.data.data.data)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postSubstitute({
  data,
  toastMessage,
  singleGame,
  setOpenSubs,
  season_id,
  isFirstTeam,
  lineup_id,
  enqueueSnackbar,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`substitutes`, data);
      dispatch(
        slice.actions.postSubstituteSuccess({
          data: response.data.data,
        })
      );
      toast(toastMessage, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      await dispatch(
        updatePlayerInMatch({
          data: {
            active: 0,
            game_id: data?.game_id,
            team_id: data?.team_id,
            player_id: data?.out_player,
          },
          enqueueSnackbar,
          lineup_id,
          isFirstTeam,
        })
      );

      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      setOpenSubs(false);
    } catch (error) {
      toast.error(error.message || "Error");
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteActivity({
  activity_id,
  toastMessage,
  singleGame,
  setOpenDelete,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axiosInstance.delete(`substitutes/${activity_id}`);
      dispatch(slice.actions.deleteActivitySuccess(activity_id));

      toast(toastMessage, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );
      setOpenDelete(false);
    } catch (error) {
      setOpenDelete(false);
      toast.error(error.message || "Error");
      dispatch(slice.actions.hasError(error));
    }
  };
}
